<div class="modal-scss">
  <section class="restrictHeight50vh">
    @if (loaded) {
      <form [formGroup]="formCreateEditPlasticLiner" class="mt-3 row">
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.destinationFolder' | translate }}</label>
          <span>{{ selectedRowData?.node.data.description }}</span>
        </div>
        <div class="col-md-12 mb-3 p-fluid">
          <label class="input-label d-block"> {{ 'classification.service' | translate }} * </label>
          <p-treeSelect
            [emptyMessage]="'noResultFound' | translate"
            [options]="servicesParentSingleSelection"
            #treeSelectCreatePlasticLiner
            class="treeSelectCreatePlasticLiner"
            selectionMode="single"
            [placeholder]="'pleaseSelectAService' | translate"
            [(ngModel)]="selectedOptionCreatePlasticLiner"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
            (onNodeSelect)="select($event)"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false">
          </p-treeSelect>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.classificationCode' | translate }} * </label>
          <p-dropdown
            styleClass="w-100"
            [virtualScroll]="true"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="classementsLV | sort: 'label' : 'ASC'"
            [filter]="true"
            [placeholder]="'classification.chooseACode' | translate"
            [showClear]="true"
            optionLabel="folderNameAndCode"
            optionValue="id"
            formControlName="classementId">
            <ng-template let-item pTemplate="selectedItem">
              <div>{{ item.folderNameAndCode }}</div>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div class="ui-helper-clearfix">
                <div>{{ item.folderNameAndCode }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.description' | translate }} * </label>
          <textarea rows="5" cols="30" formControlName="description" class="super-compos-input-text form-control w-100" pInputTextarea></textarea>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.location' | translate }} </label>
          <i-input
            [iInput]="{ placeholder: 'classification.location' | translate }"
            [type]="'text'"
            [control]="formCreateEditPlasticLiner.get('localisation')"
            [showError]="false"
            styleClass="d-block w-100"></i-input>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.remarks' | translate }} </label>
          <textarea rows="3" cols="30" formControlName="remarques" class="super-compos-input-text form-control w-100" pInputTextarea></textarea>
        </div>
      </form>
    }
  </section>

  <i-button styleClass="bottomButton red mb-3" [text]="'cancel' | translate" (click)="closeModalCreatePlasticLiner(false)"></i-button>
  <i-button
    [disabled]="formCreateEditPlasticLiner.invalid"
    styleClass="bottomButton green mb-3"
    (click)="createPlasticLiner('single')"
    [text]="'classification.createAPlasticLiner' | translate">
  </i-button>
  <i-button
    [disabled]="formCreateEditPlasticLiner.invalid"
    styleClass="bottomButton green"
    (click)="createPlasticLiner('multiple')"
    [text]="'classification.addAndCreateAnotherPlasticLiner' | translate">
  </i-button>
</div>
